// API bindings: dashboard (Auto generated)

"use strict";

import { RequestErrorHandler, RequestParams, CommonAuthenticatedErrorHandler } from "@asanrom/request-browser";
import { getApiUrl } from "./utils";
import { DashboardResponse } from "./definitions";

export class ApiDashboard {
    /**
     * Method: GET
     * Path: /dashboard
     * Gets the complete monitoring dashboard in one response.
     * @returns The request parameters
     */
    public static GetDashboard(): RequestParams<DashboardResponse, CommonAuthenticatedErrorHandler> {
        return {
            method: "GET",
            url: getApiUrl(`/dashboard`),
            handleError: (err, handler) => {
                new RequestErrorHandler()
                    .add(401, "*", handler.unauthorized)
                    .add(500, "*", "serverError" in handler ? handler.serverError : handler.temporalError)
                    .add("*", "*", "networkError" in handler ? handler.networkError : handler.temporalError)
                    .handle(err);
            },
        };
    }
}
